module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticClass: "table-shin-expand",
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.ProductName))]), _vm._v(" "), _c('p', {
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户物料名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.CustomerProductName))]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.CustomerProductCode),
            expression: "props.row.CustomerProductCode"
          }],
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.CustomerProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "BrandName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "ModelName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "ModuleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "租赁数量",
      "prop": "RentalQuantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保修期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.WarrantyMonths) + "个月/" + _vm._s(props.row.WarrantyAmount) + "元")]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e0b1245"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Lease/LeaseDetailTableCancel.vue
// module id = 749
// module chunks = 0